
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-11d9e17b&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Perfil.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Perfil.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-11d9e17b!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Perfil.vue"),
  /* scopeId */
  "data-v-11d9e17b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/perfilUsuario/Perfil.vue
// module id = 909
// module chunks = 1